import React from "react";
import PropTypes from "prop-types";
import AutoComplete from "MODULES/shared/components/AutoComplete/AutoComplete";
import formField from "../formField";

export class AutoCompleteInput extends React.Component {
  onChange = () => {
    this.props.input.onChange(null);
  };

  onSelect = item => {
    const { input, onItemSelected } = this.props;
    const value = (item && item.id) || null;

    input.onChange(value);
    input.onBlur(value);
    if (onItemSelected) onItemSelected(item);
  };

  render() {
    const {
      addon,
      autoFocus,
      search,
      selectedItem,
      formatItem = item => item && item.id,
      placeholder = "",
      input,
      disabled = false,
      allowUserInput,
      watch,
      forceClear,
      meta
    } = this.props;

    return (
      <AutoComplete
        autoFocus={autoFocus}
        search={search}
        onSelect={this.onSelect}
        format={formatItem}
        hasId={allowUserInput ? true : !!input.value}
        value={selectedItem && formatItem(selectedItem)}
        placeholder={placeholder}
        disabled={disabled}
        addon={addon}
        watch={watch}
        forceClear={forceClear}
        meta={meta}
      />
    );
  }
}

export default formField(AutoCompleteInput);

AutoCompleteInput.propTypes = {
  autoFocus: PropTypes.bool,
  input: PropTypes.instanceOf(Object).isRequired,
  search: PropTypes.func.isRequired,
  onItemSelected: PropTypes.func,
  placeholder: PropTypes.string,
  selectedItem: PropTypes.instanceOf(Object),
  formatItem: PropTypes.func,
  forceClear: PropTypes.number,
  disabled: PropTypes.bool,
  addon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  allowUserInput: PropTypes.bool,
  watch: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/AutoCompleteField/AutoCompleteField.jsx